import { JSX } from "react";
import { ShowEstablishmentDetailsHeader } from "./components/ShowEstablishmentDetailsHeader";
import { ShowEstablishmentDetailsContent } from "./components/ShowEstablishmentDetailsContent";

const ShowEstablishmentDetailsPageContainer = (): JSX.Element => {
    return (
        <div className={"p-show-establishment-details"}>
            <ShowEstablishmentDetailsHeader />
            <ShowEstablishmentDetailsContent />
        </div>
    );
};

export default ShowEstablishmentDetailsPageContainer;
